
import cars  from "@/store/modules/viewer/cars";
import fields from "@/store/modules/viewer/fields";
import visitors from "@/store/modules/viewer/visitors";
import orders from "@/store/modules/viewer/orders";
import organizations from "@/store/modules/viewer/organizations";

export default {
    namespaced: true,
    modules: {
        cars,
        fields,
        visitors,
        orders,
        organizations
    }
}